import React from "react";
import DungeonComponent from "../component/dungeon/dungeon";

const Dungeon = () => {
  return (
    <div className="dungeon-page">
      <DungeonComponent />
    </div>
  );
};

export default Dungeon;
